import { z } from 'zod';

export const zRecorderExecutionType = z.enum(['record', 'preview']);
export type RecorderExecutionType = z.infer<typeof zRecorderExecutionType>;
